import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';

const useStyles = makeStyles({
  root: {
    fontSize: '1.25em',
    opacity: 0.25,
    transition: 'opacity 0.1s ease',
  },
});

export default function Icon(props) {
  const classes = useStyles();
  return <i className={clsx(classes.root, props.className)} {...props} />;
}
